import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import isEmpty from 'lodash/isEmpty'

import { REWARD_TYPE } from '../../constants'
import {
    Button,
    Bons,
    Gold,
} from 'react-wot-bootstrap'

import {
    GET_REWARD_TEXT,
    GET_REWARD_TITLE,
    GET_REWARD_NOT_AVAILABLE,
    GET_REWARD_REWARD_RECEIVED,
    GET_REWARD_REWARD_RECEIVED_TITLE,
} from './translations'

import styles from './Footer.scss'

export class Footer extends React.Component {
    static propTypes = {
        reward: PropTypes.object,
        isRewardsProcessing: PropTypes.bool.isRequired,
        isRewardsTaken: PropTypes.bool.isRequired,
        getRewards: PropTypes.func.isRequired,
    }

    render() {
        const { reward, isRewardsTaken, isRewardsProcessing, getRewards } = this.props
        const baseClassNames = classNames(
            styles.base,
            !isEmpty(reward) && styles.base__haveReward,
            isRewardsTaken && styles.base__gotReawrd,
        )
        const buttonLightClassNames = classNames(
            styles.buttonLight,
            isRewardsProcessing && styles.buttonLight__fade,
        )

        return (
            <div className={baseClassNames}>
                <div className={styles.content}>
                    {
                        isRewardsTaken ?
                            (
                                <div className={styles.rewardHolder}>
                                    <div className={styles.receivedTitle}>{GET_REWARD_REWARD_RECEIVED_TITLE}</div>
                                    {GET_REWARD_REWARD_RECEIVED}
                                </div>
                            ) :
                            !isEmpty(reward) ?
                                (
                                    <div className={styles.rewardHolder}>
                                        <div className={styles.title}>
                                            {GET_REWARD_TITLE}
                                        </div>
                                        <div className={styles.reward}>
                                            {reward[REWARD_TYPE.BONDS] &&
                                                <Bons
                                                    size="large"
                                                    iconPosition="after"
                                                    value={reward[REWARD_TYPE.BONDS]}
                                                    mixClassName={styles.bonds}
                                                />
                                            }
                                            {reward[REWARD_TYPE.GOLD] &&
                                                <Gold
                                                    size="large"
                                                    value={reward[REWARD_TYPE.GOLD]}
                                                    iconPosition="after"
                                                    mixClassName={styles.gold}
                                                />
                                            }
                                        </div>
                                        <div className={buttonLightClassNames}>
                                            <Button
                                                onClick={() => getRewards()}
                                                mixClassName={styles.buttonGetReward}
                                                isPending={isRewardsProcessing}
                                                type="primary"
                                            >
                                                {GET_REWARD_TEXT}
                                            </Button>
                                        </div>
                                    </div>
                                ) :
                                (
                                    <span className={styles.text}>
                                        { GET_REWARD_NOT_AVAILABLE }
                                    </span>
                                )
                    }
                </div>
            </div>
        )
    }
}

export default Footer


// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/components/Footer/Footer.jsx